module.exports = __webpack_public_path__ + "static/media/Clarifai.7c0402e7.svg";